'use strict'

import Vue from 'vue'
import * as type from './types'
import actions from './actions'
import getters from './getters.js'

const state = {
  quotes: [],
  isFetching: false,
  errors: []
}
   
const mutations = {
  [type.SET_QUOTE_LIST] (state, action) {
    state.quotes = action.quote
  },
  [type.QUOTE_LIST_FETCHING] (state, action) {
    state.isFetching = action.isFetching
  },
  [type.QUOTE_LIST_ERROR] (state, action) {
    state.errors.push(action.errors)
  },
  [type.QUOTE_LIST_CLEAR_ERROR] (state) {
    state.errors = []
  },
  // [type.ADD_QUOTE_LIST] (state) {
  //   state.addedQuotes = action.quote
  // },
  [type.UPDATE_QUOTE_LIST] (state, action) {
    state.quotes.push(...action.requestObject)
  },
  [type.QUOTE_REJECTED] (state, action) {
    const quote = state.quotes.find(quote => quote.quoteID === action.quoteID)
    quote.status = 'Rejected'
  },
  [type.QUOTE_ACCEPTED] (state, action) {
    console.log(state.quotes)
    const quote = state.quotes.find(quote => quote.quoteID === action.quoteID)
    console.log(quote)
    quote.status = 'Accepted'
  },
  [type.REQUEST_CANCELED] (state, action) {
    const quote = state.quotes.find(quote => quote.quoteID === action.quoteID)
    quote.status = 'Canceled'
  },
}

export default {
    state,
    mutations,
    actions,
    getters
  } 
